import { ResponseConfig } from '@byted/tiktok-zti-types';
import { formatUrl } from '../../utils';
import { sendBecon, sendLog, EventNameMap } from '../base';
import { getSlardar } from '@/slardar';

interface TypeLogBdTicketGuardConsumerResponse {
  logid: string;
  path: string;
  ticket_guard_version: number;
  ticket_guard_iteration_version: number;
  request_with_csr: 0 | 1;
  request_with_cert: 0 | 1;
  request_with_client_data: 0 | 1;
  client_data_content_with_ts_sign?: 0 | 1; // 目前获取不到，暂时不做上报
  client_data_content_with_req_sign?: 0 | 1; // 目前获取不到，暂时不做上报
  error_code?: number;
  login_status?: string;
  sign_version?: string;
  cookie_status?: string;
  data_from?: string;
  cookie_crypt?: string;
  iframe_status?: string;
  match_md5_local?: string;
  match_md5_iframe?: string;
  is_pubkey_ts_sign?: string; // 是否为公钥生成ts_sign
  iframe_connection?: string;
  iframe_retrycount?: string;
  lost?: string;
  init_match?: string;
  is_new_cert?: string;
  // 域名
  hostname?: string;
  cookie_domain?: string;
}

// 使用票据接口的repsonse结果
export const logBdTicketGuardConsumerResponse = (ctx: any, otherInfo?: any) => {
  let path = '';
  try {
    path = formatUrl(ctx?.config?.url);
  } catch (error) {}
  const bdTtErrorCode = ctx?.headers?.['tt-ticket-guard-result'] || '-99';
  const logid = ctx?.headers?.['x-tt-logid'] || '';
  const ticketGuardVersion = ctx?.reqHeaders?.['tt-ticket-guard-version'];
  const ticketGuardIterationVersion = ctx?.reqHeaders?.['tt-ticket-guard-iteration-version'];
  const requestWithCsr = ctx?.reqHeaders?.['tt-ticket-guard-client-csr'] ? 1 : 0;
  const requestWithCert = ctx?.reqHeaders?.['tt-ticket-guard-client-cert'] ? 1 : 0;
  const requestWithClientData = ctx?.reqHeaders?.['tt-ticket-guard-client-data'] ? 1 : 0;
  const loginStatus = ctx?.loginStatus || '-1';
  const cookieStatus = ctx?.cookieStatus || '0';
  const signVersion = ctx?.signVersion || '0';
  const webDomain = ctx?.webDomain || '3';
  const dataFrom = otherInfo?.dataFrom || '-99';
  const crossStatus = otherInfo?.crossStatus || '-99';
  const cookieCrypt = ctx?.cookieCrypt || '0';
  const match_md5_local = otherInfo?.match_md5_local || '-99';
  const match_md5_iframe = otherInfo?.match_md5_iframe || '-99';
  const is_pubkey_ts_sign = otherInfo.is_pubkey_ts_sign || '1';
  const iframe_connection = otherInfo?.isConnection || '-99';
  const iframe_retrycount = otherInfo?.retryCount || '-99';
  const lost = otherInfo?.lost || '0';
  const init_match = otherInfo?.initMatch || '0';
  const is_new_cert = otherInfo?.is_new_cert || '0';
  const hostname = window?.location?.hostname || '';

  sendLog<TypeLogBdTicketGuardConsumerResponse>(EventNameMap.logWebBdTicketGuardConsumerResponse, {
    logid,
    path,
    ticket_guard_version: ticketGuardVersion,
    ticket_guard_iteration_version: ticketGuardIterationVersion,
    request_with_csr: requestWithCsr,
    request_with_cert: requestWithCert,
    request_with_client_data: requestWithClientData,
    error_code: bdTtErrorCode,
    login_status: loginStatus,
    sign_version: signVersion,
    cookie_status: cookieStatus,
    data_from: dataFrom,
    cookie_crypt: cookieCrypt,
    iframe_status: crossStatus,
    match_md5_local,
    match_md5_iframe,
    is_pubkey_ts_sign,
    iframe_connection,
    iframe_retrycount,
    lost,
    init_match,
    is_new_cert,
    hostname,
    cookie_domain: webDomain
  });

  // 单独上报失败
  if (bdTtErrorCode > 0) {
    sendLog<TypeLogBdTicketGuardConsumerResponse>(EventNameMap.logWebBdTicketGuardConsumerResponseError, {
      logid,
      path,
      ticket_guard_version: ticketGuardVersion,
      ticket_guard_iteration_version: ticketGuardIterationVersion,
      request_with_csr: requestWithCsr,
      request_with_cert: requestWithCert,
      request_with_client_data: requestWithClientData,
      error_code: bdTtErrorCode,
      login_status: loginStatus,
      sign_version: signVersion,
      cookie_status: cookieStatus,
      data_from: dataFrom,
      cookie_crypt: cookieCrypt,
      iframe_status: crossStatus,
      match_md5_local,
      match_md5_iframe,
      is_pubkey_ts_sign,
      iframe_connection,
      iframe_retrycount,
      lost,
      init_match,
      is_new_cert,
      hostname,
      cookie_domain: webDomain
    });
  }
};

interface TypeLogBdTicketGuardEnv {
  is_support_localstorage: 1 | 0;
  is_support_indexdb: 1 | 0;
  is_support_websql?: 1 | 0;
}

// 用户设备支持情况
export const logBdTicketGuardEnv = (parmas: {
  isSupportLocalstorage: boolean;
  isSupportIndexdb: boolean;
  isSupportWebsql?: boolean;
}) => {
  sendLog<TypeLogBdTicketGuardEnv>(EventNameMap.logWebBdTicketGuardEnv, {
    is_support_localstorage: parmas?.isSupportLocalstorage ? 1 : 0,
    is_support_indexdb: parmas?.isSupportIndexdb ? 1 : 0
    // is_support_websql: parmas?.isSupportWebsql ? 1 : 0,
  });
};

interface TypeBdTicketGuardLocalMiss {
  status: 'new' | 'normal' | 'miss';
}

// 用户设备local_miss情况
export const logBdTicketGuardLocalMiss = (parmas: TypeBdTicketGuardLocalMiss) => {
  sendLog<TypeBdTicketGuardLocalMiss>(EventNameMap.logWebBdTicketGuardLocalMiss, {
    status: parmas?.status
  });
};

interface BdTicketGuardIframeStatusBeforeUnload {
  // iframe状态
  iframe_status: '0' | '1';
}
export const logBdTicketGuardIframeStatusBeforeUnload = (params: BdTicketGuardIframeStatusBeforeUnload) => {
  sendBecon(EventNameMap.logWebBdTicketGuardIframeStatusBeforeUnLoad, params);
};

interface TypeBdTicketGuardIframeStatus {
  // iframe状态
  iframe_status: '0' | '1';
}

export const logBdTicketGuardIframeStatus = (parmas: TypeBdTicketGuardIframeStatus) => {
  sendLog<TypeBdTicketGuardIframeStatus>(EventNameMap.logWebBdTicketGuardIframeStatus, parmas);
};

const _getSlardar = () => {
  if ((window as any).$SECURE_REGION) {
    return getSlardar({
      sdkVersion: (window as any).$SECURE_VERSION,
      region: (window as any).$SECURE_REGION
    });
  }
  return null;
};

export const logFullPath = (response: ResponseConfig, ticket: string, type: 'consumer' | 'provider') => {
  _getSlardar()?.dot?.({
    name: EventNameMap.logFullPath,
    categories: {
      ticket,
      path: formatUrl(response.config.url),
      method: response.config.method,
      result: response.headers['tt-ticket-guard-result'],
      serverData: response.headers['tt-ticket-guard-server-data'],
      clientData: response.reqHeaders['tt-ticket-guard-client-data'],
      publicKey: response.reqHeaders['tt-ticket-guard-public-key'],
      type,
      logid: response.headers['x-tt-logid']
    },
    metrics: {}
  });
};

export const logPerformance = (params: {
  process_request_duration: number;
  process_response_duration: number;
  sign_type: string;
  store_type: string;
  path: string;
  method: string;
}) => {
  _getSlardar()?.dot?.({
    name: EventNameMap.logPerformance,
    categories: {
      sign_type: params.sign_type,
      store_type: params.store_type,
      path: params.path,
      method: params.method
    },
    metrics: {
      process_request_duration: params.process_request_duration,
      process_response_duration: params.process_response_duration
    }
  });
};

export const logGetStorage = (params: { duration: number; key: string; storage_type: string }) => {
  _getSlardar()?.dot?.({
    name: EventNameMap.logGetStorage,
    categories: {
      key: params.key,
      storage_type: params.storage_type
    },
    metrics: {
      duration: params.duration
    }
  });
};

export const logSetStorage = (params: { duration: number; key: string; storage_type: string }) => {
  _getSlardar()?.dot?.({
    name: EventNameMap.logSetStorage,
    categories: {
      key: params.key,
      storage_type: params.storage_type
    },
    metrics: {
      duration: params.duration
    }
  });
};

export const logGenerateKeys = (params: { duration: number; type: string }) => {
  _getSlardar()?.dot?.({
    name: EventNameMap.logGenerateKeys,
    categories: {
      type: params.type
    },
    metrics: {
      duration: params.duration
    }
  });
};

export const logGenerateCSR = (params: { duration: number; type: string }) => {
  _getSlardar()?.dot?.({
    name: EventNameMap.logGenerateCSR,
    categories: {
      type: params.type
    },
    metrics: {
      duration: params.duration
    }
  });
};

export const logSign = (params: { duration: number; type: string }) => {
  _getSlardar()?.dot?.({
    name: EventNameMap.logSign,
    categories: {
      type: params.type
    },
    metrics: {
      duration: params.duration
    }
  });
};

export const logStorageFail = (params: {
  message: string;
  type?: string;
  action?: string;
  category: string;
}) => {
  _getSlardar()?.dot?.({
    name: EventNameMap.logStorageFail,
    categories: {
      type: params.type,
      message: params.message,
      action: params.action,
      category: params.category
    },
    metrics: {}
  });
};
